// Simple hook wrappers for Customer Interactions
import { CI } from '../ci';
import { useOnceSync } from './useOnceSync';
import type { CustomerInteraction } from '../constants';

export function useEndCi(event: CustomerInteraction): void {
  useOnceSync(CI.end, event);
}

export function useEndCiWith(...params: Parameters<typeof CI.endWith>): void {
  useOnceSync(CI.endWith, ...params);
}

export function useStartCi(event: CustomerInteraction): void {
  useOnceSync(CI.start, event);
}
